export enum UserRole {
  Master = "Master",
  Admin = "Adm",
  User = "User",
}
